import { getPublicRuntimeConfigValue } from '../../config';

const publishEnabled = getPublicRuntimeConfigValue<boolean>(
  'analytics.dataLayer.enabled',
);

const getOrCreateDataLayer = () => (window.dataLayer = window.dataLayer || []);

export const getEventSender = () => ({
  log: (event: object) => {
    if (!publishEnabled) {
      // eslint-disable-next-line no-console
      console.log(`DataLayer Event:`, event);
      return;
    }

    getOrCreateDataLayer().push(event);
  },
});
